export default "__VITE_ASSET__DqsKmXoW__"